import { ValidateJSModel } from 'forms/shared/types';
import { hasYesOrNo } from 'models/validate';
import { pvqFinancialEvictionItemValidator } from './validators/item';
import { FinancialEvictionModel } from './types';

const financialEvictionValidator: ValidateJSModel<FinancialEvictionModel> = {
  HasEviction: {
    hasValue: { validator: hasYesOrNo },
  },

  List: (value, attributes) => {
    if (attributes?.HasEviction?.value === 'Yes') {
      return {
        presence: true,
        accordion: { validator: pvqFinancialEvictionItemValidator },
      };
    }

    return {};
  },
};

export default financialEvictionValidator;
